import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { User } from "../models/user";
import { LoadingDataService } from "../repositories/loading-data.service";
import { CryptoService } from "../services/crypto.service";
import { BaseDataService } from "./base-data.service";

@Injectable({
  providedIn: "root",
})
export class LoginDataService extends BaseDataService {
  constructor(
    private client: HttpClient,
    private cryptoService: CryptoService,
    public loadingDataService: LoadingDataService
  ) {
    super(client, loadingDataService);
  }

  public getDefaultUser(delegate: (user: User) => void): void {
    this.get<User>("users/default", delegate);
  }

  public loginUser(
    phone: string,
    token: string,
    external: boolean,
    initialUrl: string,
    delegate: (user: User) => void,
    onError?: (error: any) => void
  ): void {
    this.httpClient
      .post<User>(
        this.getUrl(`users/authenticate`),
        {
          phone: this.cryptoService.encrypt(phone),
          token,
          external,
          initialUrl
        },
        { headers: { errors: "handled" } }
      )
      .subscribe(delegate, onError);
  }

  public verifyUser(
    user: User,
    onComplete: (user: User) => void,
    onError: (error: any) => void
  ): void {
    this.httpClient
      .post<User>(this.getUrl("users/verify"), user)
      .subscribe(onComplete, onError);
    // this.post<User>('users/verify', user, delegate);
  }

  public editUser(key: string, delegate: (user: User) => void): void {
    this.get<User>("users/edituser?key=" + key, delegate);
  }
}
